import { FormControl } from '@angular/forms';
import { OfferViewDTO } from './offer-view-dto.type';

export type MerchandiseControls = {
  id: FormControl;
  position: FormControl;
  newName: FormControl;
  forceQuotation: FormControl;
  offers: FormControl;
};

export interface IMerchandise {
  id?: number;
  position?: number | null;
  newName?: string | null;
  oldName?: string | null;
  offers?: OfferViewDTO[];
  forceQuotation: boolean;
}

export class Merchandise implements IMerchandise {
  constructor(
    public id?: number,
    public position?: number | null,
    public newName?: string | null,
    public oldName?: string | null,
    public offers?: OfferViewDTO[],
    public forceQuotation = false
  ) {}
}
